import { render } from "./InputTextArea.vue?vue&type=template&id=7fb5710e&ts=true"
import script from "./InputTextArea.vue?vue&type=script&lang=ts"
export * from "./InputTextArea.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__